import { render } from "./patent-count.vue?vue&type=template&id=be2e9726&scoped=true"
import script from "./patent-count.vue?vue&type=script&lang=js"
export * from "./patent-count.vue?vue&type=script&lang=js"

import "./patent-count.vue?vue&type=style&index=0&id=be2e9726&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2e9726"]])

export default __exports__